import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import RemoveIcon from '@material-ui/icons/Remove';

import UpdateField from '../UpdateField/UpdateField';
import formatter from '../utils/formatter';

import styles from './updateRow.module.css';

const UpdateRow = ({
    field,
    value,
    onChange,
    onRemove,
    isSavedOrPreview,
    year
}) => (
    <div className={styles.container}>
        <div className={styles.label}>
            <Typography variant="subtitle1" component="label">{field}</Typography>
        </div>
        <div className={styles.field}>
            {isSavedOrPreview ? <Typography className={styles.preview} variant="subtitle1" component="label">{formatter(field, value)}</Typography> 
                     : <UpdateField
                    field={field}
                    value={value}
                    onChange={onChange}
                    year={year}
                       />
            }
        </div>
        {!isSavedOrPreview && <div className={styles['remove-icon']}>
                        <RemoveIcon style={{ fontSize: 28 }} onClick={onRemove} tabIndex="0" onKeyPress={onRemove} />
                    </div>
        }
    </div>
);

UpdateRow.propTypes = {
    field: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    isSavedOrPreview: PropTypes.bool,
    year: PropTypes.string

};

export default UpdateRow;